import { Box, Typography } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../../store/rootReducer";
import { SinglePreview } from "../ImagePreview";
import styles from "../ImageUploader.module.scss";
import { removeImage, selectImageByType } from "../images.slice";
import { Image, ImageSectionId, ImageId, SetFileAction } from "../types";

export type ImagePreviewProps = {
  readonly setFile: SetFileAction;
  readonly imageId: ImageId;
  readonly imageSectionId: ImageSectionId;
  readonly label: string;
};

const shouldDisplayPreview = (
  src: Image["src"],
  isDuringCompression: Image["isDuringCompression"],
  isCorrupted: Image["isCorrupted"]
) => src || isDuringCompression || isCorrupted;

export const withImagePreview =
  (WrappedComponent: any) =>
  ({
    imageId,
    imageSectionId,
    label,
    ...restProps
  }: ImagePreviewProps): JSX.Element => {
    const dispatch = useDispatch();
    const image: Image = useSelector((state: RootState) =>
      selectImageByType(state, { section: imageSectionId, type: imageId })
    );
    const handleOnFileRemove = () =>
      dispatch(removeImage({ section: imageSectionId, type: imageId }));

    return (
      <Box>
        {shouldDisplayPreview(
          image.src,
          image.isDuringCompression,
          image.isCorrupted
        ) ? (
          <SinglePreview image={image} onFileRemove={handleOnFileRemove} />
        ) : (
          <WrappedComponent
            {...restProps}
            imageId={imageId}
            imageSectionId={imageSectionId}
          />
        )}
        <Typography className={styles.label}>{label}</Typography>
      </Box>
    );
  };
